import script from "./list-game-name.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-game-name.vue?vue&type=script&setup=true&lang=ts"

import "./list-game-name.vue?vue&type=style&index=0&id=be224a2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be224a2a"]])

export default __exports__